import Flickity from 'flickity-fade';
import imagesLoaded from 'imagesloaded';

/** * Carousel Slider ***/

const columnSliderNodeList = document.querySelectorAll(
  '.column-carousel__slider',
);


const arrowShape = 'M36.5525409 78.6880277 33.1036463 82.1666667 0 48.7717324 33.1036463 15.5 36.5525409 18.9750154 8.8501292 46.3366851 100 46.3366851 100 51.2067797 8.8501292 51.2067797';
const draggable = Modernizr.touchevents;
const fade = !Modernizr.touchevents;
const wrapAround = true;



const columnSlideshowsArray = [];

const screenTest = (event) => {
  const groupCells = event.matches ? 2 : 1;
  const pageDots = !event.matches;
  const prevNextButtons = event.matches;

  const newOptions = {
    arrowShape,
    draggable,
    fade,
    wrapAround,

    groupCells,
    pageDots,
    prevNextButtons,
  };

  columnSlideshowsArray.forEach((slideshow) => {
    slideshow.destroy();
  });

  while (columnSlideshowsArray.length > 0) {
    const slideshow = columnSlideshowsArray.pop();
    slideshow.destroy();
  }

  columnSliderNodeList.forEach((slideshowEl) => {
    const flickitySlideshow = new Flickity(slideshowEl, newOptions);
    columnSlideshowsArray.push(flickitySlideshow);
  });

  columnSliderNodeList.forEach(slideshowEl => {
    const imgLoad = imagesLoaded(slideshowEl);

    imgLoad.on('progress', (instance) => {
      let flkty = Flickity.data(instance.elements[0]);

      flkty.resize();
    });
  });
};

const mediaQueryList = window.matchMedia('(min-width: 720px)');

mediaQueryList.addListener(screenTest);

document.addEventListener('DOMContentLoaded', () => {
  screenTest(mediaQueryList);
});
